<template>
  <v-card class="mx-auto" elevation="16" max-width="100hv">
    <v-card-item>
      <v-card-title> Secciones </v-card-title>

      <v-card-subtitle> Listado de Secciones </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <div v-if="showSeccionsFrontera">
        <v-row>
          <v-col cols="12" style="margin-bottom: -2.4em">
            <h3 class="text-start h-big" style="color: gray">
              Secciones de Frontera
            </h3>
          </v-col>
        </v-row>
        <v-row class="gap-y-6">
          <v-col
            v-for="section in listNameSections"
            :key="section.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <div class="section-card">
              <!-- <div 
              class="card-background"
              :style="{ backgroundImage: 'url(' + section.imageUrl + ')' }"
            ></div> -->

              <div class="card-content">
                <h3>{{ section.name[language] }}</h3>
                <div class="text-center">
                  <button
                    @click="goToUpdatePage(section.route)"
                    class="action-btn secondary-btn"
                    style="background-color: #c63a37"
                  >
                    <span class="language-tag">Update Content</span> <span style="margin-left: 16px;">Editar</span>
                  </button>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <div v-if="showSeccionsCobre">
        <v-row>
          <v-col cols="12" style="margin-bottom: -2.4em">
            <h3 class="text-start h-big" style="color: gray">
              Secciones de Cobre
            </h3>
          </v-col>
        </v-row>

        <v-row class="gap-y-6">
          <v-col
            v-for="section in listNameSectionsCobre"
            :key="section.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <div class="section-card">
              <!-- <div 
              class="card-background"
              :style="{ backgroundImage: 'url(' + imageUrl + ')' }"
            ></div> -->

              <div class="card-content">
                <h3 class="section-title">{{ section.name[language] }}</h3>
                <div class="button-group text-center">
                  <button
                    @click="goToUpdatePage(section.route)"
                    class="action-btn secondary-btn"
                    style="background-color: #F15A29"
                  >
                    <span class="language-tag">Update Content</span> <span style="margin-left: 16px;">Editar</span>
                  </button>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
import { getLanguageForUpdateContent } from "@/kernel/utils";

export default defineComponent({
  name: "ListSections",
  setup() {
    const imageUrl =
      "https://www.rami-spare.it/media/images/cache/macchine-movimento-terra-cover_jpg_1024_0_cover_60.jpg";
    const listNameSections = ref([
      {
        id: 1,
        name: {
          EN: "Home",
          ES: "Inicio",
        },
        route: "update-home",
        imageUrl: imageUrl,
      },
      {
        id: 2,
        name: {
          EN: "Gallery",
          ES: "Galería",
        },
        route: "update-gallery",
        imageUrl: "https://api3.cobredelmayo.com/api/public/img/bg-about.jpg",
      },
      {
        id: 3,
        name: {
          EN: "About",
          ES: "Nosotros",
        },
        route: "update-about",
        imageUrl: "https://api3.cobredelmayo.com/api/public/img/bg-about.jpg",
      },
      {
        id: 4,
        name: {
          EN: "History",
          ES: "Historia",
        },
        route: "update-history",
        imageUrl: "https://api3.cobredelmayo.com/api/public/img/bg-history.jpg",
      },
      {
        id: 5,
        name: {
          EN: "Location",
          ES: "Ubicación",
        },
        route: "update-location",
        imageUrl: "https://api3.cobredelmayo.com/api/public/img/bg-location.jpg",
      },
      {
        id: 6,
        name: {
          EN: "Operations",
          ES: "Operaciones",
        },
        route: "update-operations",
        imageUrl: "https://api3.cobredelmayo.com/api/public/img/bg-tbu.jpg",
      },
      {
        id: 7,
        name: {
          EN: "ESG",
          ES: "ASG",
        },
        route: "update-esg",
        imageUrl: "https://api3.cobredelmayo.com/api/public/img/bg-tbu.jpg",
      },
    ]);

    const listNameSectionsCobre = ref([
      {
        id: 8,
        name: {
          EN: "Home",
          ES: "Inicio",
        },
        route: "update-home-cobre",
        imageUrl: imageUrl,
      },
      {
        id: 9,
        name: {
          EN: "Contact",
          ES: "Contacto",
        },
        route: "update-contact-cobre",
        imageUrl: imageUrl,
      },
    ]);

    const language = ref("ES");
    const loading = ref(false);
    const showSeccionsFrontera = ref(false);
    const showSeccionsCobre = ref(false);

    const goToUpdatePage = async (nameRoute) => {
      await router.push({ name: nameRoute });
    };

    const route = useRoute();

    const fetchSections = async () => {
      language.value = getLanguageForUpdateContent();
      try {
        const incomingZone = route.query.zone || "both";
        console.log("Incoming zone:", incomingZone);
        if (incomingZone === "frontera") {
          showSeccionsFrontera.value = true;
          showSeccionsCobre.value = false;
        } else if (incomingZone === "cobre") {
          showSeccionsFrontera.value = false;
          showSeccionsCobre.value = true;
        } else {
          showSeccionsFrontera.value = true;
          showSeccionsCobre.value = true;
        }
      } catch (error) {
        console.error("Error fetching sections:", error);
      }
    };

    onMounted(() => {
      fetchSections();
    });

    return {
      listNameSections,
      listNameSectionsCobre,
      loading,
      goToUpdatePage,
      imageUrl,
      showSeccionsFrontera,
      showSeccionsCobre,
      language
    };
  },
});
</script>

<style scoped>
.sections-container {
  background: transparent !important;
}

.header {
  background: linear-gradient(45deg, #f8fafc 0%, #f1f5f9 100%);
}

.section-card {
  position: relative;
  height: 180px;
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #f5f5f5;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.section-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.card-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.4;
  mix-blend-mode: multiply;
}

.card-content {
  position: relative;
  height: 80%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  margin-bottom: 8px !important;
}

.primary-btn {
  background: #3b82f6;
  color: white;
}

.primary-btn:hover {
  background: #2563eb;
  box-shadow: 0 4px 6px rgba(59, 130, 246, 0.3);
}

.secondary-btn {
  background: #f59e0b;
  color: white;
}

.secondary-btn:hover {
  background: #d97706;
  box-shadow: 0 4px 6px rgba(245, 158, 11, 0.3);
}

.language-tag {
  font-size: 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
}
</style>
